import { GameSettings } from './game.interface';

export enum RoomStatus {
  WAITING = 'WAITING',
  STARTING = 'STARTING',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
}

export interface Room {
  id: string;
  joinCode: string; // URL-safe capability token — possessing it authorises joining
  roomName: string;
  hostId: string;
  playerIds: string[];
  password?: string;
  hasPassword: boolean;
  status: RoomStatus;
  createdAt: number;
  startedAt?: number;
  readyPlayers: Record<string, boolean>; // socketId -> isReady
  settings: GameSettings;
}
